// ============================================================================
// MÓDULO DE SERVIÇOS: WHATSAPP SERVICE (V1.0 - HYBRID LINK/API)
// ARQUIVO: src/services/WhatsAppService.js
// OBJETIVO: Centralizar lógica de comunicação. Hoje Link, Amanhã API.
// ============================================================================

export const WhatsAppService = {
  /**
   * Gera link universal "Click-to-Chat" (Modo Atual - Custo Zero)
   * @param {string} phone - Número do telefone (com ou sem 55)
   * @param {string} message - Texto da mensagem (suporta Markdown)
   */
  generateLink: (phone, message) => {
    if (!phone) return "#";

    // Limpeza e Padronização
    let cleanPhone = phone.replace(/\D/g, "");

    // Adiciona DDI 55 se não tiver (assumindo BR para números de 10/11 dígitos)
    if (cleanPhone.length >= 10 && cleanPhone.length <= 11) {
      cleanPhone = "55" + cleanPhone;
    }

    const encoded = encodeURIComponent(message);
    return `https://wa.me/${cleanPhone}?text=${encoded}`;
  },

  /**
   * STUB: Envio via API (Evolution API / Baileys)
   * Preparado para a Fase 5 (Serverless Container)
   */
  sendViaAPI: async (phone, message) => {
    console.log(" [FUTURE] Enviando via API...", { phone, message });
    // Futura implementação: fetch para Cloud Run
    return { success: true };
  },
};
